<div class="top-section">
  <div *ngIf="pageName.includes('IBOXX')" class="searchBarDiv search-area searchBar" style="display: flex">
    <div id="searchBarLi" class="search-input-group search-group">
      <div class="input-icons">
        <input type="text" class="short typeahead" name="x" id="EntitySearchBox" (keyup)="searchTerm($event)"
             placeholder="Search by ISIN, Index Name or Bloomberg Ticker..." [(ngModel)]="searchInput">
        <i class="site-icon-cross icon pointer-cursor" *ngIf="searchInput.trim().length > 0" (click)="searchTerm($event)"></i>
      </div>
      <div class="predictiveSearch values" *ngIf="searched && searchResult.length > 0"
           [ngStyle]="{'display': searched ? 'block' : 'none'}">
        <div style="background: #bfbfbf; text-align: center; font-weight: bold"> {{searchResult.length}} results found.</div>
        <div style="  overflow: auto;">
          <table class="results" [ngStyle]="{'display': searched ? 'block' : 'none'}"
               style="table-layout: fixed; margin-bottom: 0; width: 1010px; max-height: 500px">
          <tr *ngFor="let searchField of searchResult">
            <td style="width: 180px;">ISIN: <span><b [innerHTML]="searchField.isin"></b></span></td>
            <td style="width: 650px"> Index Name: <span><span class="link"
                                        (click)="navigateToIndexByName(searchField)"
                                        [innerHTML]="searchField.name"></span></span></td>
            <td style="width: 180px">BBG Ticker: <span><b [innerHTML]="searchField.bbgTicker"></b></span></td>
          </tr>
        </table>
        </div>
      </div>
      <div class="predictiveSearch values no-search-found" *ngIf="searched && searchResult.length === 0"
           style="display: block; width: 560px">
        <span *ngIf="searchInput && !searchTimedOut"> No Result for '{{searchInput}}' found.</span>
        <span *ngIf="searchTimedOut"> >1000 results returned, please refine your search.</span>
      </div>
      <div class="input-group-btn">
        <i class="site-icon-search-button"></i>
      </div>
      <div style="background-color: rgba(255, 255, 255, 0.75); height: 32px; width: 32px" [ngStyle]="{'visibility': this.showLoader ? 'visible' : 'hidden'}">
        <img src="assets/Mini%20balls-small.gif" style="animation: rotation 2s infinite linear;">
      </div>
    </div>
    <div class="notification-bar"><p>This website is showing a selection of iBoxx indices. For any further information, please contact <span class="link"  (click)="mailMe()">indices@ihsmarkit.com</span>.</p>
    </div>
  </div>
  <span class="page-heading"> {{pageName}} </span>

  <lib-side-nav-lib [menuItems]='items' [menuConfig]="menuConfig"
                    (urlChangeEvent)='navigateToPage($event)'></lib-side-nav-lib>
  <lib-ihsm-alert-notification class="alert-box" *ngIf="showAlert" [message]="alertMessage" (close)="closeAlert()"
                               [messageType]="alertType"></lib-ihsm-alert-notification>
  <lib-ihsm-alert-notification class="alert-box" *ngIf="indexNotInHeadline" [message]="indexNotFoundMsg"
                               (close)="closeAlert()" [messageType]="alertType"></lib-ihsm-alert-notification>
  <lib-ihsm-alert-notification class="alert-box"
                               *ngIf="showErrorMsg" [message]="errorMessage" (close)="closeAlert()" [messageType]="errorType">
  </lib-ihsm-alert-notification>
</div>
